<template>
	<!-- <sf-data-table ref="dataTable" :columns="userMappingCols" :rows="users" selection :style="{ height: '65vh' }" /> -->
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<!-- 사용자 목록 -->
			</div>
			<sf-data-table
				:totalSize="users.pagingInfo.totalSize"
				:currentPage="users.pagingInfo.currentPage"
				:pageUnit="10"
				paging
				:rows="users.resultList"
				:columns="columns"
				height="100%"
				@changedPage="changedPage"
				@row-click="selectRow"
				:pageArray="screen.pageArray"
			>
			</sf-data-table>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return { screen: {} };
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000420'),
					prop: 'rnum',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000217'),
					prop: 'userId',
					width: '170px'
				},
				{
					label: this.getMessage_('SWCC000218'),
					prop: 'userName',
					width: '180px'
				},
				{
					label: this.getMessage_('SWCC000106'),
					prop: 'useYn',
					width: '180px'
				},
				{
					label: this.getMessage_('SWCC000404'),
					prop: 'nouseLockDays',
					width: '210px'
				},
				{
					label: this.getMessage_('SWCC000405'),
					prop: 'pwdExpDays',
					width: '210px'
				},
				{
					label: this.getMessage_('SWCC000407'),
					prop: 'remark',
					width: '150px'
				},
				{
					label: this.getMessage_('SWCC000408'),
					prop: 'lastLoginDt',
					width: '220px'
				},
				{
					label: this.getMessage_('SWCC000409'),
					prop: 'lastPwdChgDt',
					width: '270px'
				},
				{
					label: this.getMessage_('SWCC000146'),
					prop: 'regDt',
					width: '220px'
				},
				{
					label: this.getMessage_('SWCC000005'),
					prop: 'regId',
					width: '150px'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			this.$emit('refreshUser', currentPageVal, pageUnitVal);
		},
		formatter(row, column) {
			let columnValue = '';
			this.useYnList.forEach(item => {
				if (row.useYn == item.commCd) {
					columnValue = item.commCdName;
				}
			});

			return columnValue;
		},
		selectRow(row) {
			this.$emit('SelectUser', row);
		}
	}
};
</script>

<style></style>
